<template>
  <el-row
    v-if="fieldList && fieldList.length > 0"
    :gutter="10"
    style="height：auto"
  >
    <el-col :span="24">
      <el-card :shadow="shadow || 'never'" :class="noBorder && 'no-border'">
        <div v-if="formTitle" class="panel-title">{{ $t(formTitle) }}</div>
        <!-- 表单 -->
        <template>
          <el-form
            ref="pageform"
            :model="data"
            :rules="rules"
            size="mini"
            label-width="100px"
          >
            <el-col
              v-for="(item, index) in getConfigList()"
              :key="index"
              :xs="item.xs || 12"
              :sm="item.sm || 12"
              :md="item.md || 12"
              :lg="item.lg || 12"
              :xl="item.xl || 12"
            >
              <el-form-item :prop="item.value" :label="$t(item.label)" :required="item.required">
                <!-- 选择框 -->
                <el-select
                  style="width: 220px"
                  v-if="item.type === 'select'"
                  v-model="data[item.value]"
                  :label-width="item.labelWidth"
                  :disabled="item.disabled"
                  :clearable="item.clearable === false ? item.clearable : true"
                  :multiple="item.multiple === true ? item.multiple : false"
                  :filterable="item.filterable"
                  :placeholder="getPlaceholder(item)"
                  @change="handleEvent(item.event, data[item.value])"
                >
                  <el-option
                    v-for="(childItem, childIndex) in listTypeInfo[item.list]"
                    :key="childIndex"
                    :label="childItem.key"
                    :value="childItem.value"
                  />
                </el-select>
                <!-- 数字输入框 -->
                <el-input-number
                  style="width: 220px"
                  v-else-if="item.type === 'number'"
                  v-model="data[item.value]"
                  :placeholder="getPlaceholder(item)"
                  :disabled="item.disabled"
                  :min="item.min || 0"
                  :max="item.max"
                  :precision="item.precision || 0"
                  controls-position="right"
                />
                <!-- 普通输入框 -->
                <el-input
                  style="width: 220px"
                  v-else-if="item.type === 'input'"
                  v-model="data[item.value]"
                  :placeholder="getPlaceholder(item)"
                  :disabled="item.disabled"
                  :readonly="item.readonly"
                  @change="(e) => handleEvent(item.event, e)"
                />
                <!-- 密码输入框 -->
                <el-input
                  style="width: 220px"
                  v-else-if="item.type === 'password'"
                  v-model="data[item.value]"
                  :placeholder="getPlaceholder(item)"
                  :disabled="item.disabled"
                  type="password"
                />
                <!--多行输入框 -->
                <el-input
                  v-else-if="item.type === 'textarea'"
                  v-model="data[item.value]"
                  :placeholder="getPlaceholder(item)"
                  :disabled="item.disabled"
                  type="textarea"
                />
                <!-- 二选一单选框 -->
                <template v-else-if="item.type === 'radio'">
                  <el-radio-group
                    v-model="data[item.value]"
                    @change="(value) => handleEvent(item.event, value)"
                  >
                    <el-radio
                      :label="item.yes || 'Y'"
                      :disabled="item.disabled"
                      :placeholder="$t(item.yesLabel) || getPlaceholder(item)"
                      >{{ item.yesLabel || $t("table.yes") }}</el-radio
                    >
                    <el-radio
                      :label="item.no || 'N'"
                      :disabled="item.disabled"
                      :placeholder="$t(item.noLabel) || getPlaceholder(item)"
                      >{{ item.noLabel || $t("table.no") }}</el-radio
                    >
                  </el-radio-group>
                </template>
                <!-- 时间范围选择 -->
                <template v-else-if="item.type === 'picker'">
                  <el-col :span="11">
                    <el-time-picker
                      v-model="data[item.startTime.value]"
                      :placeholder="getPlaceholder(item)"
                      :disabled="item.disabled"
                      format="HH:mm"
                      value-format="HH:mm"
                      style="width: 100%"
                    />
                  </el-col>
                  <el-col
                    v-if="item.startTime && item.endTime"
                    class="line text-center"
                    :span="1"
                    >-</el-col
                  >
                  <el-col :span="11">
                    <el-time-picker
                      v-model="data[item.endTime.value]"
                      :placeholder="getPlaceholder(item)"
                      :disabled="item.disabled"
                      format="HH:mm"
                      value-format="HH:mm"
                      style="width: 100%"
                    />
                  </el-col>
                </template>
                <!-- 日期范围选择 -->
                <el-date-picker
                  v-else-if="item.type === 'daterange'"
                  v-model="data[item.value]"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="daterange"
                  align="right"
                  unlink-panels
                  :range-separator="$t('date.to')"
                  :start-placeholder="$t('date.startDate')"
                  :end-placeholder="$t('date.endDate')"
                  :picker-options="item.options"
                />
                <!-- 日期选择 -->
                <el-date-picker
                  v-else-if="item.type === 'date'"
                  v-model="data[item.value]"
                  value-format="yyyy-MM-dd"
                  align="right"
                  :placeholder="getPlaceholder(item)"
                  :picker-options="item.options"
                  :format="item.format || 'yyyy-MM-dd'"
                  :disabled="item.disabled"
                  @change="(e) => handleEvent(item.event, e)"
                />
                <!-- 日期、时间选择器 -->
                <template v-else-if="item.type === 'dateTime'">
                  <el-col v-if="item.date" :span="11">
                    <el-date-picker
                      v-model="data[item.date.value]"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      type="date"
                      :placeholder="getPlaceholder(item)"
                      :disabled="item.disabled"
                      style="width: 100%"
                    />
                  </el-col>
                  <el-col v-else-if="item.startTime" :span="11">
                    <el-time-picker
                      v-model="data[item.startTime.value]"
                      :placeholder="getPlaceholder(item)"
                      :disabled="item.disabled"
                      format="HH:mm"
                      value-format="HH:mm"
                      style="width: 100%"
                    />
                  </el-col>
                  <el-col
                    v-if="(item.date || item.startTime) && item.time"
                    class="line text-center"
                    :span="1"
                    >-</el-col
                  >
                  <el-col v-if="item.time" :span="11">
                    <el-time-select
                      v-if="item.time.type === 'timeSelect'"
                      v-model="data[item.time.value]"
                      :disabled="item.disabled"
                      :picker-options="{
                        start: '00:30',
                        step: '00:30',
                        end: '24:00',
                      }"
                      :placeholder="getPlaceholder(item)"
                    />
                    <el-time-picker
                      v-else
                      v-model="data[item.time.value]"
                      :placeholder="getPlaceholder(item)"
                      :disabled="item.disabled"
                      format="HH:mm"
                      value-format="HH:mm"
                      style="width: 100%"
                    />
                  </el-col>
                </template>
                <!-- 地址选择 -->
                <div v-else-if="item.type === 'address'" class="item-inline">
                  <el-col :span="18">
                    <el-input
                      v-model="data[item.value]"
                      :disabled="item.disabled"
                      placeholder="地址"
                    />
                  </el-col>
                  <el-col :span="4">
                    <el-button
                      size="mini"
                      :disabled="item.disabled"
                      @click="handleClick(item.event)"
                      >获取经纬度</el-button
                    >
                  </el-col>
                </div>
                <!-- 城市选择 -->
                <el-cascader
                  v-else-if="item.type === 'cities'"
                  v-model="data[item.value]"
                  :props="{ value: 'label' }"
                  :options="citiesOP"
                  filterable
                  style="width: 100%"
                  :disabled="item.disabled"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <slot />
            </el-col>
          </el-form>
        </template>
      </el-card>
    </el-col>
  </el-row>
</template>
<script>
import cities from "@/common/cities"; // 引入城市数据

export default {
  props: {
    // 自定义类名
    className: {
      type: String,
    },
    //表单标题
    formTitle: {
      type: String,
    },
    // 表单数据
    data: {
      type: Object,
    },
    // 相关字段
    fieldList: {
      type: Array,
    },
    // 验证规则
    rules: {
      type: Object,
    },
    // 相关的列表
    listTypeInfo: {
      type: Object,
    },
    refObj: {
      type: Object,
    },
    //阴影效果
    shadow: {
      type: String,
    },
    //不显示边框
    noBorder: {
      type: Boolean,
    },
  },
  data() {
    return {
      form: {
        carriers: "全部",
      },
      dialogImageUrl: "",
      dialogVisible: false,
      citiesOP: cities,
    };
  },
  computed: {
    getTableConfigList() {
      return this.table.fieldList.filter(
        (item) =>
          !item.hasOwnProperty("show") ||
          (item.hasOwnProperty("show") && item.show)
      );
    },
  },
  watch: {
    data: {
      handler: function (val) {
        // 将form实例返回到父级
        this.$emit("update:refObj", this.$refs.pageform);
      },
      deep: true, // 深度监听
    },
  },
  mounted() {
    console.log(this.rules, this.data)
    // 将form实例返回到父级
    this.$emit("update:refObj", this.$refs.pageform);
  },
  methods: {
    // 获取字段列表
    getConfigList() {
      return this.fieldList.filter(
        (item) =>
          !item.hasOwnProperty("show") ||
          (item.hasOwnProperty("show") && item.show)
      );
    },
    // 得到placeholder的显示
    getPlaceholder(row) {
      let placeholder;
      if (row.type === "input" || row.type === "textarea") {
        placeholder = this.$t("table.input") + this.$t(row.label);
      } else if (
        row.type === "select" ||
        row.type === "time" ||
        row.type === "date" ||
        row.type === "picker"
      ) {
        placeholder = this.$t("table.select") + this.$t(row.label);
      } else if (row.type === "number") {
        placeholder = "请输入数字";
      } else {
        placeholder = this.$t(row.label);
      }
      return placeholder;
    },
    // 绑定的相关事件
    handleEvent(evnet, data) {
      this.$emit("handleEvent", evnet, data);
    },
    // 派发按钮点击事件
    handleClick(event, data) {
      this.$emit("handleClick", event, data);
    },
    //select框远程搜索
    remoteMethod(item, query) {
      item.loading = false;
      this.handleEvent(item.remoteMethod, query);
    },
  },
};
</script>
<style scoped>
.no-border {
  border: 0;
}
.dialog-panel .no-border .el-card__body {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog-form.vue